var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EventsFromTopLeaguesBySportIdRequest, EventsBySportIdRequest } from "sb-bff-integration";
import { MarketTypeRequest } from "sbtech-online-sportcontent-sportbook";
import { compareArrays } from "../compareArrays";
export var bffRequestBuilder = {
    buildSportIdsUpdate: function (params, sportIds) {
        this.buildIds(params.request, sportIds);
        this.buildEventTags(params.request);
        this.buildMarketIdsByType(params, sportIds);
    },
    buildDateRangeUpdate: function (params, dateRange) {
        this.buildDateRange(params.request, dateRange);
        this.buildEventTags(params.request);
        this.buildMarketIdsByType(params, params.request.ids);
    },
    buildLeagueIdsUpdate: function (params, leagueIds, sportIds) {
        this.buildIds(params.request, leagueIds);
        this.buildMarketIdsByType(params, sportIds);
    },
    buildRegionIdUpdate: function (params, regionId, sportId, pagination) {
        this.buildSportId(params.request, sportId);
        this.buildRegionId(params.request, regionId);
        this.buildMarketIdsByType(params);
        this.buildPagination(params.request, pagination);
    },
    buildEventTagsUpdate: function (params, eventTags) {
        this.buildIds(params.request, params.allSportIds);
        this.buildEventTags(params.request, eventTags);
        this.buildMarketIdsByType(params);
    },
    buildEventIdsUpdate: function (params, favoriteEvents) {
        this.buildIds(params.request, favoriteEvents.map(function (ev) { return ev.eventId; }));
        this.buildMarketIdsByType(params, favoriteEvents.map(function (ev) { return ev.sportId; }).filter(function (id, i, array) { return array.indexOf(id) === i; }));
    },
    buildSportIdRequest: function (request, pagination) {
        var result = __assign({}, request);
        this.buildExcludeRegionIds(result, request.regionIds);
        this.buildRegionIds(result, undefined);
        this.buildLeagueState(result, EventsBySportIdRequest.LeagueStateEnum.Regular);
        this.buildPagination(result, pagination);
        return result;
    },
    buildPagination: function (request, pagination) {
        request.pagination = pagination;
    },
    buildLeagueState: function (request, leagueState) {
        request.leagueState = leagueState;
    },
    buildExcludeRegionIds: function (request, regionIds) {
        request.excludeRegionIds = regionIds;
    },
    buildRegionIds: function (request, regionIds) {
        request.regionIds = regionIds;
    },
    buildRegionId: function (request, regionId) {
        request.regionId = regionId;
    },
    buildIds: function (request, ids) {
        request.ids = ids;
    },
    buildSportId: function (request, sportId) {
        request.sportId = sportId;
    },
    buildDateRange: function (request, dateRange) {
        request.dateRange = dateRange;
    },
    buildEventTags: function (request, eventTags) {
        if (eventTags === void 0) { eventTags = []; }
        request.eventTags = eventTags;
    },
    buildMarketTypeRequests: function (params, sportIds) {
        var _this = this;
        if (sportIds === void 0) { sportIds = []; }
        var marketTypeRequests = [];
        var defaultMarkets = this.buildMarketIds(params.request.eventState, params.cardConfiguration["0"].markets);
        var defaultConfiguration = {
            sportIds: [],
            marketTypeIds: defaultMarkets,
            statement: MarketTypeRequest.StatementEnum.Include
        };
        var sportIdsToExclude = [];
        if (!sportIds.length) {
            sportIds = Object.keys(params.cardConfiguration).filter(function (k) { return k !== "0"; });
            sportIdsToExclude = Object.keys(params.cardConfiguration).filter(function (k) { return k !== "0"; });
        }
        sportIds.forEach(function (sportId) {
            var config = params.cardConfiguration[sportId];
            if (!config) {
                defaultConfiguration.sportIds.push(sportId);
            }
            else {
                var marketTypeIds = _this.buildMarketIds(params.request.eventState, config.markets);
                if (sportIdsToExclude.length && compareArrays(marketTypeIds, defaultMarkets)) {
                    var index = sportIdsToExclude.indexOf(sportId);
                    index > -1 && sportIdsToExclude.splice(index, 1);
                }
                else {
                    marketTypeRequests.push({
                        sportIds: [sportId],
                        marketTypeIds: marketTypeIds,
                        statement: MarketTypeRequest.StatementEnum.Include
                    });
                }
            }
        });
        params.request.marketTypeRequests = marketTypeRequests;
        sportIdsToExclude.length && params.request.marketTypeRequests.push({
            sportIds: sportIdsToExclude,
            marketTypeIds: defaultConfiguration.marketTypeIds,
            statement: MarketTypeRequest.StatementEnum.Exclude
        });
        if (defaultConfiguration.sportIds.length || !params.request.marketTypeRequests.length) {
            defaultConfiguration.sportIds = this.buildDefaultSportIds(defaultConfiguration.sportIds, sportIds);
            params.request.marketTypeRequests.push(defaultConfiguration);
        }
    },
    buildMarketIds: function (eventState, markets) {
        return !eventState || eventState === EventsFromTopLeaguesBySportIdRequest.EventStateEnum.Mixed
            ? markets.map(function (m) { return m.idLive; }).concat(markets.map(function (m) { return m.idPreLive; })).filter(function (value, index, self) { return self.indexOf(value) === index; })
            : markets.map(function (m) { return m["id" + eventState]; });
    },
    buildDefaultSportIds: function (defaultIds, sportIds) {
        return defaultIds.length === sportIds.length ? [] : defaultIds;
    },
    buildMarketIdsByType: function (params, sportIds) {
        if (params.request.eventTypes && params.request.eventTypes.indexOf(EventsBySportIdRequest.EventTypesEnum.Outright) > -1) {
            return;
        }
        this.buildMarketTypeRequests(params, sportIds);
    }
};
//# sourceMappingURL=bffRequestBuilder.js.map